function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("defs", null);

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M11.79,15.24l-.44.21-.02.01h.02l.44-.21a1,1,0,0,0,.24-.16A.974.974,0,0,1,11.79,15.24Z",
  transform: "translate(-0.003)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M23.93,16.9a2.21,2.21,0,0,0-2.67-1.58l-6.43,1.76a.615.615,0,0,1-.14.01l-2.78-.43.46-.22a2.137,2.137,0,0,0,1.01-.98H18.2a1.311,1.311,0,0,0,1.3-1.27V6.2a1.007,1.007,0,0,0-.36-.69L13.36.39a.812.812,0,0,0-.1-.09L13.25.29a.01.01,0,0,1-.01-.01c-.02-.01-.04-.03-.06-.04s-.03-.01-.04-.02a1.484,1.484,0,0,0-.31-.15c-.03-.01-.06-.01-.09-.02A1.931,1.931,0,0,0,12.32,0a1.512,1.512,0,0,0-.85.24c-.02.01-.04.03-.06.04-.04.04-.08.07-.12.11L4.86,5.51a1.007,1.007,0,0,0-.36.69v7.75L.31,16.68a.662.662,0,1,0,.72,1.11l3.99-2.6.76-.49a.334.334,0,0,1,.12-.05l2.22-.52.38-.09h.01l1.32-.31,1.35-.31a.962.962,0,0,1,1.08.54c.02.05.04.11.06.16v.01a.983.983,0,0,1-.29.96,1,1,0,0,1-.24.16l-.44.21h-.02l-1.95.93a.678.678,0,0,0-.37.7.668.668,0,0,0,.56.56l4.92.75a1.66,1.66,0,0,0,.7-.04l6.4-1.76a.894.894,0,0,1,1.06.64.884.884,0,0,1-.55,1.05l-7.16,2.75a.321.321,0,0,1-.17.02L8.39,20.3a1.871,1.871,0,0,0-.71.07L.47,22.7a.651.651,0,0,0-.43.83A.66.66,0,0,0,.67,24a.448.448,0,0,0,.2-.04l7.21-2.32a.44.44,0,0,1,.16-.02l6.38.76a1.688,1.688,0,0,0,.8-.1l7.16-2.74A2.212,2.212,0,0,0,23.93,16.9ZM5.83,13.29V6.44l6.29-5.01.09-.09c.02,0,.06-.01.11-.01a.308.308,0,0,1,.1.01h.01c.01.01.01.01.02.01s.01.01.02.02l.01.01,5.69,5.05v7.7H15.5V9.53a1.071,1.071,0,0,0-1.07-1.07H9.57A1.071,1.071,0,0,0,8.5,9.53v3.14Zm7.64.12a2.307,2.307,0,0,0-2.58-1.29l-1.06.25V9.79h4.34v4.34h-.51v-.01A2.028,2.028,0,0,0,13.47,13.41Z",
  transform: "translate(-0.003)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M8.51,14.04H8.5v.01l1.33-.31v-.01Z",
  transform: "translate(-0.003)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M12.03,15.09a1,1,0,0,1-.24.16l-.44.21h-.02l.02-.01.44-.21A.974.974,0,0,0,12.03,15.09Z",
  transform: "translate(-0.003)"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24.001,
    height: 24,
    viewBox: "0 0 24.001 24"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
};

export default __webpack_public_path__ + "static/media/mortgage.ce5bf800.svg";
export { SvgComponent as ReactComponent };